import { TitreTexteCtaImage } from '@components/titre-texte-cta-image/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const titreTexteCtaImageMock = (
  backgroundColor: 'gray' | 'white' = 'white',
  withText: boolean = false,
  withPictos: boolean = false,
  showImageOnMobile: boolean = false
): Block<TitreTexteCtaImage> => ({
  type: 'titre-texte-cta-image',
  data: {
    title: {
      text: `Chez nous y’a que les oignons [[qui font pleurer]]`,
      as: 'h2',
    },
    text: withText
      ? `<ul><li>Comparez plusieurs estimation pour afficher votre budget</li><li>Estimez le budget de votre cuisine en quelques clics</li><li>Récupérez vos estimations directement dans votre boite mail</li></ul>`
      : undefined,
    cta: {
      label: `J'estime mon budget`,
      url: '/mock-estimateur',
    },
    background: backgroundColor,
    image: imageMock,
    pictos: withPictos
      ? [
          {
            svg: '/assets/tmp/store.svg',
          },
          {
            svg: '/assets/tmp/store.svg',
          },
        ]
      : undefined,
    showImageOnMobile,
    gtmConfigCta: {
      event: 'click_cta_estimation',
      group: 'estimation',
      description: 'lp estimation budget',
      context: 'clic vers tunnel estimation',
    },
  },
});
